import React from 'react'
import { Icon } from '@mobi/component-library/Common/Icon'

export function SearchIcon({ size }: { size?: string }) {
  return <Icon type='search' size={size ? size : undefined} color='white' />
}
